<template>
  <el-card>
    <div class="toolbar">
      <el-button @click="onPlatformClick" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 平台点位情况 </el-button
      >&nbsp;
      <div class="former">
        <el-input
          v-model="form['Name:like']"
          placeholder="站点名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="platformid"
          labelName="PlatformName"
          url="platform"
          placeholder="请选择业务平台"
          noDataText="无业务平台"
          :currentList="currentPlatform"
        ></select2
        >&nbsp;
        <el-cascader
          v-model="area"
          :options="options"
          :props="props"
          clearable
          placeholder="所属地区"
          :show-all-levels="true"
          :emitPath="false"
        ></el-cascader
        >&nbsp;
        <select2
          v-model="businesstypeid"
          url="basic?where[Type]=businesstype_ipc"
          placeholder="业务类型"
          noDataText="无类型"
          style="width: 120px"
        ></select2
        >&nbsp;
        <el-select
          v-model="form.NetWorkingState"
          clearable
          placeholder="联网状态"
          style="width: 100px"
        >
          <el-option label="已联网" :value="1"></el-option>
          <el-option label="更换中" :value="2"></el-option>
          <el-option label="已过保" :value="3"></el-option>
        </el-select>
        &nbsp;
        <!-- <el-select v-model="upperheartbeat" clearable placeholder="请选择上位点位在线状态">
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>&nbsp; -->
        <el-select
          v-model="heartbeat"
          clearable
          placeholder="在线状态"
          style="width: 120px"
        >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option> </el-select
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <div id="app">
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
      ></el-table-column>
      <el-table-column label="关注" align="center" width="50">
        <template scope="scope">
          <i
            v-if="scope.row.Focus"
            class="el-icon-star-on"
            style="color: #e6a23c; cursor: pointer; font-size: 25px"
            @click="onFocus(scope.row, 'off')"
          ></i>
          <i
            v-if="!scope.row.Focus"
            class="el-icon-star-off"
            style="color: #c6e2ff; cursor: pointer; font-size: 20px"
            @click="onFocus(scope.row, 'on')"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="站点名称" width="170"
        ><template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.Name">
            <a
              target="_self"
              class="buttonText"
              @click="showStaton(scope.row)"
              >{{ scope.row.Name }}</a
            >
          </el-link>
        </template></el-table-column
      >
      <el-table-column label="所属地区" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.Province">{{ scope.row.Province.Name }}</span>
          <span v-if="scope.row.City">/{{ scope.row.City.Name }}</span>
          <span v-if="scope.row.County">/{{ scope.row.County.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型"
        width="80"
      ></el-table-column>
      <el-table-column prop="PlatformName" label="关联平台" width="180">
        <template slot-scope="{ row }">
          <span v-if="row.Platforms && row.Platforms.length">
            {{ row.Platforms[0].PlatformName }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="NetWorkingState"
        label="联网状态"
        width="80"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.NetWorkingState === 1" type="success">
            已联网
          </el-tag>
          <el-tag v-if="row.NetWorkingState === 2" type="warning">
            更换中
          </el-tag>
          <el-tag v-if="row.NetWorkingState === 3" type="danger">
            已过保
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="在线状态" align="center" width="50">
        <!-- <el-table-column label="业务平台" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.UpperHeartBeat === true" title="在线">
              <div class="circle-h bg-success"></div>
            </span>
            <span v-else title="离线">
              <div class="circle-h bg-danger"></div>
            </span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="现场端" align="center" width="80"> -->
          <template slot-scope="scope">
            <span v-if="scope.row.HeartBeat === true" title="在线">
              <div class="circle-h bg-success"></div>
            </span>
            <span v-else title="离线">
              <div class="circle-h bg-danger"></div>
            </span>
          </template>
        <!-- </el-table-column> -->
      </el-table-column>
      <el-table-column label="数据条数" align="center">
        <el-table-column label="昨日小时" align="center" width="80">
          <template slot-scope="{ row }">
            <span
              v-if="row.YestStationDatas && row.YestStationDatas.length > 0"
              :class="[
                row.YestStationDatas[0].ActHourCnt !==
                row.YestStationDatas[0].TheoryHourCnt
                  ? 'text-danger'
                  : '',
              ]"
            >
              {{ row.YestStationDatas[0].ActHourCnt }}/
              {{ row.YestStationDatas[0].TheoryHourCnt }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="今日小时" align="center" width="80">
          <template slot-scope="{ row }">
            <span
              v-if="row.StationDatas && row.StationDatas.length > 0"
              :class="[
                row.StationDatas[0].ActHourCnt !==
                row.StationDatas[0].TheoryHourCnt
                  ? 'text-danger'
                  : '',
              ]"
            >
              {{ row.StationDatas[0].ActHourCnt }}/
              {{ row.StationDatas[0].TheoryHourCnt }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="今日因子" align="center" width="85">
          <template slot-scope="{ row }">
            <span
              v-if="row.StationDatas && row.StationDatas.length > 0"
              :class="[
                row.StationDatas[0].ActItemDataCnt !==
                row.StationDatas[0].TheoryItemDataCnt
                  ? 'text-danger'
                  : '',
              ]"
            >
              {{ row.StationDatas[0].ActItemDataCnt }}/
              {{ row.StationDatas[0].TheoryItemDataCnt }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="最新数据时间" align="center">
        <el-table-column label="分钟" align="center" width="110">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.StationDatas.length &&
                scope.row.StationDatas[0].LatestMinuteTime
              "
            >
              {{
                scope.row.StationDatas[0].LatestMinuteTime.substring(
                  5,
                  16
                ).replace("T", " ")
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="小时" align="center" width="110">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.StationDatas.length &&
                scope.row.StationDatas[0].LatestHourTime
              "
            >
              {{
                scope.row.StationDatas[0].LatestHourTime.substring(
                  5,
                  16
                ).replace("T", " ")
              }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="StationDatas[0].Description"
        label="描述"
        header-align="center"
        show-overflow-tooltip
      >
        <template scope="scope">
          <div
            v-if="scope.row.StationDatas && scope.row.StationDatas.length > 0"
          >
            <span>{{ scope.row.StationDatas[0].Description }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    
    <el-dialog
      title="站点信息"
      :visible.sync="showVisible"
      @close="showVisible = false"
      width="80%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-station :ID="statonID" :showBack="false" :key="statonID" />
    </el-dialog>
  </el-card>
</template>

<script>
import ShowStation from "../station/index--detail.vue";

export default {
  components: {
    ShowStation,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "Name:like": "",
        NetWorkingState: "",
        ProvinceCodeID: "",
        CityCodeID: "",
        CountyCodeID: "",
      },
      businesstypeid: 0,
      platformid: 0,
      heartbeat: "",
      itemVisible: false,
      props: {
        value: "CodeID",
        label: "Name",
        children: "Children",
        checkStrictly: true,
      },
      area: [0, 0, 0],
      options: [],
      currentPlatform: [],
      showVisible: false,
      statonID:"",
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.platformid = this.$route.query.id;
      this.currentPlatform = [
        {
          ID: this.$route.query.id,
          PlatformName: this.$route.query.name,
        },
      ];
    }

    this.getItemList();
    this.choseArea();
  },
  methods: {
    onPlatformClick() {
      this.$router.push({ name: "PnPlatformNetwork" });
    },
    onFocus(row, type) {
      if (type === "on") {
        row.Focus = true;
      } else {
        row.Focus = false;
      }
      this.$axios
        .request({
          url: "ipcStationFocus",
          method: "post",
          data: {
            id: row.ID,
            focus: row.Focus,
          },
        })
        .then(() => {})
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getItemList() {
      this.loading = true;
      if (this.area[0]) this.form.ProvinceCodeID = this.area[0];
      else this.form.ProvinceCodeID = "";
      if (this.area[1]) this.form.CityCodeID = this.area[1];
      else this.form.CityCodeID = "";
      if (this.area[2]) this.form.CountyCodeID = this.area[2];
      else this.form.CountyCodeID = "";
      const params = {
        where: this.form,
        heartbeat: this.heartbeat,
        businesstypeid: this.businesstypeid,
        platformid: this.platformid,
        with: [
          "Platforms",
          "BusinessType",
          "Province",
          "City",
          "County",
        ],
        order: [
          "-focus",
          "heartbeat",
          "dataerror",
          "province_code_id",
          "city_code_id",
          "county_code_id",
          "name",
        ],
        ...this.pager,
      };
      this.$axios
        .get("ipcrealtimedata", { params })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    choseArea() {
      this.$axios
        .get("area")
        .then((response) => {
          this.options = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    showStaton(row) {
      this.statonID=row.ID;
      this.showVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 ;
    }
    /deep/ td {
      padding: 1 ;
    }
  }
}
.circle-h {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: calc(50% - 10px);
}
.el-card__body > .toolbar {
  overflow: hidden;
  background: #f5f7fa;
  padding: 15px 20px 10px;
  margin: -10px -20px 10px;
}
</style>
